module.exports = __webpack_public_path__ + "media/vrouw-behandel.0bb8efa1.mp4";